import { render, staticRenderFns } from "./ExternalMessage.vue?vue&type=template&id=2f1225c2"
import script from "./ExternalMessage.vue?vue&type=script&lang=ts"
export * from "./ExternalMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports